import { ButtonSelectMultiple } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import type { ItemType } from "../../../../clients/graphqlTypes.js";
import { useItemTypes } from "../hooks/useItemTypes.js";

interface Props {
  label?: string;
  value: ItemType[];
  onChange: (value: ItemType[]) => void;
}

export const ButtonItemTypeSelectMultiple = ({
  label,
  value,
  onChange,
}: Props) => {
  const { itemTypeOptions } = useItemTypes();
  const { t } = useTranslate(["Global", "QuoteItem"]);
  return (
    <ButtonSelectMultiple
      label={label ?? t("Type", { ns: "QuoteItem" })}
      searchLabel={t("Search", { ns: "Global" })}
      noOptionsLabel={t("There are no items to display", {
        ns: "Global",
      })}
      options={itemTypeOptions}
      value={value}
      onChange={onChange}
      popoverWidth="md"
    />
  );
};
